
import * as React from 'react';
import { ButtonGroup, Button } from '@progress/kendo-react-buttons';


const Info = () => {
  return (
    <div id="Info" className="card-buttons">
      <Button>Sentiment Analysis</Button >      
    </div>
    );
  }

export default Info;